/**
 * Falldaten für das Schreiben (Vorlagen-Platzhalter, Betreff-Bausteine,
 * Empfänger-Vorauswahl) – dieselben Abrufe für „Neue Nachricht“ und das
 * Antworten (Kundenfeedback 25.10.2026 Teil 3, I). Fehler sind unkritisch:
 * dann bleiben die betroffenen Angaben leer.
 */
import { API_BASE_URL } from '@/config'

type Records = Array<Record<string, unknown>>

export interface CaseComposeResources {
  accidents: Records
  clients: Records
  opponents: Records
  vehicles: Records
  settlement: Record<string, unknown> | null
  witnesses: Records
  policeProsecution: Records
}

async function loadList (idCase: number | string, path: string): Promise<Records> {
  try {
    const res = await fetch(`${API_BASE_URL}/protected/cases/${idCase}/${path}`, { credentials: 'include' })
    if (!res.ok) {
      return []
    }
    const data = await res.json()
    if (Array.isArray(data)) {
      return data
    }
    return data ? [data] : []
  } catch {
    return []
  }
}

export async function loadCaseComposeResources (idCase: number | string): Promise<CaseComposeResources> {
  const [accidents, clients, opponents, vehicles, settlement, witnesses, policeProsecution] = await Promise.all([
    loadList(idCase, 'accidents'),
    loadList(idCase, 'clients'),
    loadList(idCase, 'opponents'),
    loadList(idCase, 'vehicles'),
    loadList(idCase, 'settlement'),
    loadList(idCase, 'witnesses'),
    loadList(idCase, 'police-prosecution'),
  ])
  return { accidents, clients, opponents, vehicles, settlement: settlement[0] || null, witnesses, policeProsecution }
}

/** Fallart der Akte ("kasko" | "haftpflicht"); leer, wenn sie nicht ladbar ist. */
export async function loadCaseType (idCase: number | string): Promise<string> {
  try {
    const res = await fetch(`${API_BASE_URL}/protected/cases/${idCase}`, { credentials: 'include' })
    if (!res.ok) {
      return ''
    }
    const data = await res.json()
    return typeof data?.caseType === 'string' ? data.caseType : ''
  } catch {
    return ''
  }
}

/** Beteiligte der Akte (Empfänger-Kandidaten). */
export async function loadCaseInvolved (idCase: number | string): Promise<Records> {
  try {
    const res = await fetch(`${API_BASE_URL}/protected/cases/${idCase}/involved`, { credentials: 'include' })
    if (!res.ok) {
      return []
    }
    const data = await res.json()
    return Array.isArray(data) ? data : (data?.involved || [])
  } catch {
    return []
  }
}
